module.exports = __webpack_public_path__ + "img/lvshicover_sample.0a5842ce.png";